import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, Phone, ArrowUp } from "lucide-react";
import { DEFAULT_WA_MESSAGE } from "../../lib/api";
import { useContact } from "../../hooks/useSettings";
import { useLang } from "../../lib/i18n";

export const FloatingHUD = () => {
    const [showTop, setShowTop] = useState(false);
    const { callUrl, waUrl } = useContact();
    const { t } = useLang();

    useEffect(() => {
        const onScroll = () => setShowTop(window.scrollY > 600);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div className="fixed bottom-5 left-5 z-50 flex flex-col gap-3">
            <AnimatePresence>
                {showTop && (
                    <motion.button
                        initial={{ opacity: 0, scale: 0.6 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.6 }}
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        data-testid="floating-scroll-top"
                        className="w-11 h-11 rounded-full border border-white/15 bg-[#101B3D]/90 backdrop-blur flex items-center justify-center text-slate-300 hover:text-amber-400 hover:border-amber-400/50 transition-colors duration-300"
                        aria-label={t("fl_top")}
                    >
                        <ArrowUp className="w-5 h-5" />
                    </motion.button>
                )}
            </AnimatePresence>

            <motion.a
                href={callUrl}
                data-testid="floating-call-action"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.4, duration: 0.5 }}
                className="w-14 h-14 rounded-full bg-[#1B2A6B] border border-white/20 flex items-center justify-center text-white shadow-[0_10px_30px_rgba(27,42,107,0.5)] hover:bg-[#253C96] transition-colors duration-300"
                aria-label={t("fl_call")}
            >
                <Phone className="w-6 h-6" />
            </motion.a>

            <motion.a
                href={waUrl(DEFAULT_WA_MESSAGE)}
                target="_blank"
                rel="noreferrer"
                data-testid="floating-whatsapp-action"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.2, duration: 0.5 }}
                className="pulse-whatsapp w-14 h-14 rounded-full bg-emerald-500 flex items-center justify-center text-[#0A1228] shadow-[0_10px_30px_rgba(16,185,129,0.4)] hover:bg-emerald-400 transition-colors duration-300"
                aria-label={t("fl_wa")}
            >
                <MessageCircle className="w-7 h-7" />
            </motion.a>
        </div>
    );
};
